import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.33 2.83',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M3.27,2.83a.55.55,0,0,1-.36-.13.43.43,0,0,0-.29-.11.4.4,0,0,0-.28.11A.55.55,0,0,1,2,2.83a.52.52,0,0,1-.35-.13.43.43,0,0,0-.29-.11.4.4,0,0,0-.28.11.55.55,0,0,1-.36.13A.57.57,0,0,1,.34,2.7a.38.38,0,0,0-.28-.11.06.06,0,1,1,0-.12.57.57,0,0,1,.36.13.38.38,0,0,0,.28.11A.43.43,0,0,0,1,2.6a.52.52,0,0,1,.35-.13.55.55,0,0,1,.36.13A.4.4,0,0,0,2,2.71a.43.43,0,0,0,.29-.11.52.52,0,0,1,.35-.13A.53.53,0,0,1,3,2.6a.43.43,0,0,0,.29.11.06.06,0,0,1,.06.06A.06.06,0,0,1,3.27,2.83Z"
        />
        <path
          fill={fill}
          d="M.59,2.56A.06.06,0,0,1,.53,2.5v-2A.49.49,0,0,1,1,0H1A.48.48,0,0,1,1.5.48a.06.06,0,1,1-.12,0A.36.36,0,0,0,1,.12.37.37,0,0,0,.65.48v2A.06.06,0,0,1,.59,2.56Z"
        />
        <path
          fill={fill}
          d="M2.1,2.56A.06.06,0,0,1,2,2.5v-2A.49.49,0,0,1,2.52,0h0A.49.49,0,0,1,3,.48.07.07,0,0,1,3,.55s-.06,0-.06-.07A.37.37,0,0,0,2.52.12a.36.36,0,0,0-.36.36v2A.06.06,0,0,1,2.1,2.56Z"
        />
        <path
          fill={fill}
          d="M2.1,2.27H.59a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.06H2.1a.06.06,0,0,1,.06.06A.06.06,0,0,1,2.1,2.27Z"
        />
        <path
          fill={fill}
          d="M2.1,1.85H.59a.06.06,0,0,1-.06-.06.07.07,0,0,1,.06-.07H2.1a.07.07,0,0,1,.06.07A.06.06,0,0,1,2.1,1.85Z"
        />
        <path
          fill={fill}
          d="M2.1,1.42H.59a.06.06,0,0,1-.06-.06A.06.06,0,0,1,.59,1.3H2.1a.06.06,0,0,1,.06.06A.06.06,0,0,1,2.1,1.42Z"
        />
        <path
          fill={fill}
          d="M2.1,1H.59a.06.06,0,0,1,0-.12H2.1A.06.06,0,0,1,2.1,1Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
